export default "__VITE_ASSET__028382a1__"